import React, { useEffect, useRef, useState } from "react";
import { Container, Button, Modal, Nav } from "react-bootstrap";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaDesktop, FaMobileAlt } from "react-icons/fa";
import { loadFromLocalStorage } from "utils/LocalStorageUtils";
import { saveToLocalStorage } from "utils/LocalStorageUtils";
import { useNavigate } from "react-router-dom";
import LoginAskModal from "pages/loginaskmodal";

const TemplateViewing = (props) => {
    const { showModal, handleCloseModal, selectedTemplate, handleCloseLoginAskModal, showLoginAskModal, handleLoginAskModal } = props;
    const [activeTab, setActiveTab] = useState("Desktop");
    const [selectActiveTab, setSelectActiveTab] = useState(false);
    const [languageData, setLanguageData] = useState(null);
    const [isAuth, setIsAuth] = useState(false);
    const selectLang = loadFromLocalStorage("SELECTLANGUAGE");
    const navigate = useNavigate();
    useEffect(() => {
        setLanguageData(selectLang?.language)
    }, [selectLang])
    useEffect(() => {
        const authData = loadFromLocalStorage("AUTH_DATA");
        if (authData?.token) {
            setIsAuth(true)
        }
    }, []);

    // ✅ Responsive handling (works on iOS too)
    const [screenSize, setScreenSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });

    useEffect(() => {
        const handleResize = () => {
            setScreenSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };
        if (!selectActiveTab && window.innerWidth < 768) {

            setActiveTab('Mobile')
        } else if (!selectActiveTab && window.innerWidth > 768) {
            setActiveTab('Desktop')
        }
        window.addEventListener('resize', handleResize);
        // Cleanup
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [selectActiveTab]);

    let desktopBtnRef = useRef(null);
    let mobileBtnRef = useRef(null);
    let editBtnRef = useRef(null);
    useEffect(() => {
        const meta = document.querySelector('meta[name="viewport"]');
        if (meta) {
            if (showModal && selectActiveTab && activeTab === 'Desktop' && screenSize?.width < 768) {
                if (desktopBtnRef.current) {
                    desktopBtnRef.current.style.fontSize = '29px';
                }
                if (mobileBtnRef.current) {
                    mobileBtnRef.current.style.fontSize = '29px';
                }
                if (editBtnRef.current) {
                    editBtnRef.current.style.fontSize = '29px';
                }
                meta.setAttribute('content', 'width=1200, user-scalable=no');
            } else {
                if (desktopBtnRef.current) {
                    desktopBtnRef.current.style.fontSize = '13px';
                }
                if (mobileBtnRef.current) {
                    mobileBtnRef.current.style.fontSize = '13px';
                }
                if (editBtnRef.current) {
                    editBtnRef.current.style.fontSize = '13px';
                }
                meta.setAttribute('content', 'width=device-width, initial-scale=1');
            }
        }
    }, [activeTab, showModal]);

    return (
        <Container>
            {/* Modal for Viewing Template */}
            {showLoginAskModal && <LoginAskModal handleCloseLoginAskModal={handleCloseLoginAskModal} showLoginAskModal={showLoginAskModal} />}

            <Modal
                show={showModal}
                onHide={handleCloseModal}
                centered
                size={activeTab === "Desktop" ? "xl" : "md"} // Set modal size based on active tab
            >
                <Modal.Header closeButton>
                    {/* <Modal.Title>
                        <h6>{selectedTemplate?.title}</h6>
                    </Modal.Title> */}
                </Modal.Header>
                <Modal.Body>
                    {/* Tabs for switching device views */}
                    <Nav
                        variant="tabs"
                        activeKey={activeTab}
                        onSelect={(selectedTab) => {
                            setActiveTab(selectedTab);
                            setSelectActiveTab(true);
                        }}
                        className={`justify-content-center text-center align-items-center`}
                    >
                        <Nav.Item >
                            <Nav.Link ref={desktopBtnRef} eventKey="Desktop">
                                <FaDesktop className="me-2" />
                                {languageData?.desktop}
                            </Nav.Link>
                        </Nav.Item>
                        <div className="nav-separator"></div> {/* Separator line */}
                        <Nav.Item>
                            <Nav.Link ref={mobileBtnRef} eventKey="Mobile">
                                <FaMobileAlt className="me-2" />
                                {languageData?.mobile}
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item style={{ marginLeft: 20 }}>
                            <Button
                                ref={editBtnRef}
                                size="sm"
                                style={{ borderRadius: 50, margin: 10 }}
                                onClick={() => {
                                    if (isAuth) {
                                        saveToLocalStorage('selectTemplate', selectedTemplate); saveToLocalStorage("selectOrderDetail", null); navigate("/templateform"); handleCloseModal();
                                    } else {
                                        handleLoginAskModal();
                                    }
                                }}>
                                {languageData?.editThisTemplate}
                            </Button>
                        </Nav.Item>
                    </Nav>
                    {/* <img
            src={selectedTemplate?.imgSrc}
            alt={selectedTemplate?.title} 
            className="img-fluid mb-3"
            style={{ width: "100%" }}
          /> */}
                    {/* <div className="templatethumb-card">
                        <div className={activeTab === "Desktop" ? 'desktop-iframe' : 'mobile-iframe'}>

                            <iframe src={selectedTemplate?.template_path} width="100%" height={selectActiveTab && activeTab === "Desktop" && screenSize?.width < 992 ? '1500' : "500"}></iframe>
                        </div>
                    </div> */}



                    {/* <div style={containerStyles}>
                        <iframe
                            src={selectedTemplate?.template_path} // Replace with your template URL
                            title="Template Preview"
                            style={iframeStyles}
                        />
                    </div> */}

                    <div className="templatethumb-card">
                        <div className={activeTab === "Desktop" ? 'desktop-iframe' : 'mobile-iframe'}>
                            <iframe src={selectedTemplate?.template_path} width="100%" height={selectActiveTab && activeTab === "Desktop" ? '1500' : "700"}></iframe>
                        </div>
                    </div>

                    {/* <div className="templatethumb-card___">
                        <iframe src={selectedTemplate?.template_path} width="100%" height={selectActiveTab && activeTab === "Desktop" && screenSize?.width < 992 ? '1500' : "500"} style={{ zoom: selectActiveTab && activeTab === "Desktop" ? '0.32' : 1, WebkitTransform: selectActiveTab && activeTab === "Desktop" ? 'scale(0.4)' : 'scale(1)' }}></iframe>
                    </div> */}

                    {/* Template Preview Iframe */}
                    {/* <div className={activeTab === "Desktop" ? "desktop-iframe" : "mobile-iframe"}>
                        <iframe
                            src={selectedTemplate?.template_path}
                            width="100%"
                            height={activeTab === "Desktop" ? "1000" : "650"}
                            style={{
                                border: "none",
                                width: "100%",
                                borderRadius: "8px",
                                overflow: "hidden",
                                WebkitOverflowScrolling: "touch", // iOS-specific
                            }}
                            allowFullScreen
                            title="template-preview"
                        ></iframe>
                    </div> */}
                </Modal.Body>
            </Modal>
        </Container >
    );
};

export default TemplateViewing;